import React, { PureComponent } from 'react';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';

class PhoneField extends PureComponent {
  render() {
    const {
      className,
      inputClassName,
      errorMsg,
      htmlFor,
      labelText,
      labelClassName,
      autoComplete,
      ...rest
    } = this.props;

    return <div className={classNames('phone-field', className)}>
      <label htmlFor={htmlFor} className={classNames(labelClassName, { 'section-label--error': errorMsg })}>
        {labelText}
      </label>
      <NumberFormat
        data-test-id="phone-field"
        id={htmlFor}
        {...rest}
        autoComplete={autoComplete}
        className={classNames(inputClassName, {'txt-field-input--error': errorMsg })}
        display='text'
        format='(###) ###-####'
        mask='_'
        placeholder='(___) ___ - ____'
      />
      { errorMsg && <div className={'field-error-msg'}>{errorMsg}</div>}
    </div>;
  }
}

PhoneField.defaultProps = {
  inputClassName: 'txt-field-input',
  autoComplete: 'disabled'
};

export default PhoneField;

